import { useReadWeakSecretsSummaryQuery } from '@/shared/redux/api/assets/vaults/vaults-api';

export const useWeakSecretWarning = () => {
  const TWeakSecretsWarningParams = {
    pollingInterval: 60_000,
    refetchOnFocus: true,
    refetchOnReconnect: true,
  } as const;

  const { data } = useReadWeakSecretsSummaryQuery(
    undefined,
    TWeakSecretsWarningParams,
  );

  const weakSecretsCount =
    data?.readAllVaults?.items.reduce(
      (count, vault) =>
        count +
        vault.secrets.items.filter((secret) => secret.weakSecret).length,
      0,
    ) ?? 0;

  return {
    weakSecretsCount,
  };
};
